export enum CharacterCountDownVariants {
  DEFAULT,
  SHORT
}
